import { DBBCreateContractModalQueryKeys } from "components/DBB/components/DBBCreateContractModal/queryKeys";
import { useTypedQuery } from "hooks";
import { ApiInstance } from "utils/Api";

import type { DropdownItemProps } from "components";
import type { DBBLeaseCompanyID, DBBLeaseCompanySummary, DealerLocation } from "models";

const selectLeaseCompanyOptions = (leaseCompanies: DBBLeaseCompanySummary[]): DropdownItemProps<DBBLeaseCompanyID>[] =>
  leaseCompanies.map(({ id, name }) => ({ key: id, value: id, text: name }));

export const usePermanentLeaseCompanyOptionsQuery = (carLocation?: DealerLocation) =>
  useTypedQuery({
    queryKey: DBBCreateContractModalQueryKeys.leaseCompanies(carLocation?.id),
    queryFn: async ({ baseUrl, endpoint, params }) => (await ApiInstance.post(endpoint, params, baseUrl)).data.lease_companies ?? [],
    enabled: !!carLocation?.dbb_enabled,
    select: selectLeaseCompanyOptions
  });
